import { SubdomainState } from './state';

export const subdomainInitialState: SubdomainState = {

}